import { GET_POSTS_BY_PATIENT_ID } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export type Template = {
    _id: string;
    type: 'COMM' | 'SA' | 'ATTACH';
    meta: {
        display: {
            title: string;
            description: string;
            link: string;
            file_type: string;
        };
    };
    created_at: string;
    updated_at: string;
};

export type Res = Template[];

export default (patientId: string): Promise<Res> => {
    return fetchWithRefresh(GET_POSTS_BY_PATIENT_ID(patientId)).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to getPostsByPatientId');
        }
    });
};
